<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qd2sNb/tc-custom/9781846274633.jpg?1736859739683" alt="This image is the cover for the book Madame Verona Comes Down the Hill"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Madame Verona Comes Down the Hill
      </h1>
      <p class="bookDescription body article font2">
        <b>“A timeless novel about love, loss and village life” from the award-winning Dutch author of <i>The Misfortunates</i> and <i>Problemski Hotel</i> (<i>Aesthetica</i>).</b><br/>  <br/> Years ago, Madame Verona and her husband built a home for themselves on a hill in a forest above a small village. There they lived in isolation, practicing their music, and chopping wood to see them through the cold winters. When Mr. Verona died, the locals might have expected that the legendary beauty would return to the village, but Madame Verona had enough wood to keep her warm during the years it would take to make a cello—the instrument her husband loved—and in the meantime she had her dogs for company. And then one cold February morning, when the last log has burned, Madame Verona sets off down the village path, with her cello and her memories, knowing that she will have no strength to climb the hill again. Poignant, precise and perfectly structured, this is a story of one woman’s tender and enduring love—as a wife, and as a widow.<br/>  <br/> “An intimate, unsentimental portrayal of European rural life . . . In Verhulst’s landscape, nature is ruthless, amoral and never benign, and human memory a cruel mirage . . . His best sentences are gorgeously resonant.”—<i>The Herald</i><br/>  <br/> “Aging, bereavement and death are somber themes, yet this novel’s treatment of them is agreeably entertaining . . . this tale of enduring love is often preposterous, sometimes poignant and, above all, consistently charming.”—<i>The Independent</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dimitri Verhulst
      </h2>
      
      <p class="authorDescription body article">Dimitri Verhulst is the author of a collection of short stories, a volume of poetry, and several novels, including Problemski Hotel.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Portobello Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?58146aa6